import React from 'react'

export default function AMDSvgLogo() {
  return (
    <svg
      className="navbar-brand-image"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 139.72 33.32"
      fill="white"
    >
      <path
        className="cls-1"
        d="M33,31.14H25.21l-2.37-5.72H9.92L7.76,31.14H.14L11.78,2.26h8.34Zm-16.89-22L11.83,20.39h8.89Z"
        transform="translate(-0.14 -0.03)"
      />
      <path
        className="cls-1"
        d="M61.1,2.26h6.27V31.14h-7.2v-18l-7.79,9.06h-1.1L43.49,13.1v18h-7.2V2.26h6.27L51.83,13Z"
        transform="translate(-0.14 -0.03)"
      />
      <path
        className="cls-1"
        d="M85.61,2.26c10.54,0,16,6.56,16,14.48,0,8.3-5.25,14.4-16.77,14.4H72.86V2.26ZM80.06,25.85h4.7c7.24,0,9.4-4.91,9.4-9.15,0-5-2.67-9.15-9.48-9.15H80.06Z"
        transform="translate(-0.14 -0.03)"
      />
      <polygon
        className="cls-1"
        points="130.64 9.08 115.75 9.08 106.68 0 139.72 0 139.72 33.05 130.64 23.97 130.64 9.08"
      />
      <polygon
        className="cls-1"
        points="115.74 23.98 115.74 10.9 106.4 20.24 106.4 33.33 119.48 33.33 128.82 23.98 115.74 23.98"
      />
    </svg>
  )
}
